import { Link, Text, useIntl } from 'platform-components';
import { TEXT_MARKUP_TYPE, TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

import './empty-state__unavailable-subject.scss';

interface Props {
    headerTextId?: string;
}

export const UnavailableSubject = ({ headerTextId }: Props) => {
    const intl = useIntl();

    return (
        <div className="empty-state__unavailable-subject-wrapper">
            <div className="empty-state__unavailable-subject-block">
                <div className="empty-state__unavailable-subject-header">
                    <Text
                        id={headerTextId}
                        size={Text.SIZE.XXXL}
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                        weight={TEXT_WEIGHT.L}
                    />
                </div>
                <div className="empty-state__unavailable-subject-description">
                    <Text id="emptyState.unavailableSubject.description" type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </div>
                <Link to={intl.formatMessage({ id: 'emptyState.unavailableSubject.link.url' })}>
                    <Text id="emptyState.unavailableSubject.link" weight={TEXT_WEIGHT.L} />
                </Link>
            </div>
            <Link to={intl.formatMessage({ id: 'emptyState.unavailableSubject.link.url' })}>
                <div className="empty-state__teacher-block">
                    <Text id="emptyState.teacherBlock" type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </div>
            </Link>
        </div>
    );
};
